import { toast } from 'react-toastify';

export const toastTypes = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
} as const;

export type ToastType = (typeof toastTypes)[keyof typeof toastTypes];

export const showToast = (
  message: string,
  type: ToastType = toastTypes.ERROR
) => {
  // Use the message as a toastId — react-toastify will skip duplicates if a toast with the same ID is already active.
  // check if a toast with that ID is already on screen before showing a new one
  // If the same message is already visible, the new one is silently skipped.
  // Once the existing toast dismisses, the message can appear again if triggered.
  if (!toast.isActive(message)) {
    // passes toastId: message so react-toastify tracks this toast by the message, preventing duplicates
    toast[type](message, { toastId: message });
  }
};

export const showErrorToast = (message: string) =>
  showToast(message, toastTypes.ERROR);
export const showWarningToast = (message: string) =>
  showToast(message, toastTypes.WARNING);
export const showInfoToast = (message: string) =>
  showToast(message, toastTypes.INFO);
export const showSuccessToast = (message: string) =>
  showToast(message, toastTypes.SUCCESS);
